import decode from 'jwt-decode';

/**
 * Get Token Expiration Date.
 * @param {string} token - JWT
 */
export function getTokenExpirationDate(token) {
    const decoded = decode(token);
    if (!decoded.exp) {
        return null;
    }

    const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
    date.setUTCSeconds(decoded.exp);
    return date;
}

/**
 * Is Token Expired.
 * @param {string} token  JWT
 */
export function isTokenExpired(token, currentTime = null) {
    if (!token) return true;
    const date = getTokenExpirationDate(token);

    const offsetSeconds = 0;
    if (date === null) {
        return false;
    }
    return !(
        date.valueOf() >
        new Date(currentTime).valueOf() + offsetSeconds * 1000
    );
}
